import { Fragment } from 'react';
import FTab from '../components/Tabs';
import SectionPro from '../components/SectionPro';
import Fan from './icons/Fan';
import Dryer from './icons/Dryer';
import Light from './icons/Light';
import Phone from './icons/Phone';
import Kettle from './icons/Kettle';
import Microwave from './icons/Microwave';
import CircularSaw from './icons/CircularSaw';
import Drill from './icons/Drill';
import ElectricHammer from './icons/ElectricHammer';
import AngleGrinder from './icons/AngleGrinder';
import ElectricBlanket from './icons/ElectricBlanket';
import CarRefrigerator from './icons/CarRefrigerator';
import PortableAirConditioner from './icons/PortableAirConditioner';

import styles from './index.module.scss';

const ElectricalAppliances: React.FC = () => {
    const tabItems = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744958602570/800W%2BD2M%2B%E7%A9%BA%E8%B0%83%20(1).jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745402437210/%E8%BB%8A%E4%B8%AD%E6%B3%8A-h5.jpg',
            tabLabel: '車中泊',
            tabValue: '11',
            desc: [
                {
                    icon: <Fan className="icon" />,
                    label: '扇風機 (40W)',
                    title: (
                        <Fragment>
                            約<span className="bold">41</span>時間
                        </Fragment>
                    ),
                },
                {
                    icon: <Dryer className="icon" />,
                    label: 'ドライヤー (1200W)',
                    title: (
                        <Fragment>
                            約<span className="bold">1.3</span>時間
                        </Fragment>
                    ),
                },
                {
                    icon: <CarRefrigerator className="icon" />,
                    label: 'ポータブル冷蔵庫 (60W)',
                    title: (
                        <Fragment>
                            約<span className="bold">29</span>時間
                        </Fragment>
                    ),
                },
                {
                    icon: <PortableAirConditioner className="icon" />,
                    label: 'ポータブルエアコン (≤690w)',
                    title: (
                        <Fragment>
                            <span className="bold">5~20</span>時間
                        </Fragment>
                    ),
                },
            ].map((item) => {
                return (
                    <div key={item.label} className="item">
                        {item.icon}
                        <div className="right-box">
                            <div className="label">{item.label}</div>
                            <div className="title">{item.title}</div>
                        </div>
                    </div>
                );
            }),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1755742518165-dm82z7-compressed-800W%2BD2M.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1755742546887-mbjw1a-compressed-800W%2BD2M.jpg',
            tabLabel: '車中泊避難',
            tabValue: '22',
            desc: [
                {
                    icon: <Light className="icon" />,
                    label: '照明(10W)',
                    title: (
                        <Fragment>
                            約<span className="bold">116</span>時間
                        </Fragment>
                    ),
                },
                {
                    icon: <Phone className="icon" />,
                    label: 'スマホ (11W)',
                    title: (
                        <Fragment>
                            約<span className="bold">143</span>回
                        </Fragment>
                    ),
                },
                {
                    icon: <PortableAirConditioner className="icon" />,
                    label: 'ポータブルエアコン (≤690W)',
                    title: (
                        <Fragment>
                            <span className="bold">5~20</span>時間
                        </Fragment>
                    ),
                },
                {
                    icon: <Kettle className="icon" />,
                    label: '電気ケトル (1500W)',
                    title: (
                        <Fragment>
                            約<span className="bold">1.1</span>時間
                        </Fragment>
                    ),
                },
            ].map((item) => {
                return (
                    <div key={item.label} className="item">
                        {item.icon}
                        <div className="right-box">
                            <div className="label">{item.label}</div>
                            <div className="title">{item.title}</div>
                        </div>
                    </div>
                );
            }),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745399171844/D2M%20%E9%98%B2%E7%81%BE-pc.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745402437003/%E9%98%B2%E7%81%BD-h5.jpg',
            tabLabel: '防災',
            tabValue: '33',
            desc: [
                {
                    icon: <Phone className="icon" />,
                    label: 'スマホ (11W)',
                    title: (
                        <Fragment>
                            約<span className="bold">143</span>回
                        </Fragment>
                    ),
                },
                {
                    icon: <Kettle className="icon" />,
                    label: '電気ケトル (1500W)',
                    title: (
                        <Fragment>
                            約<span className="bold">1.1</span>時間
                        </Fragment>
                    ),
                },
                {
                    icon: <Microwave className="icon" />,
                    label: '電子レンジ (1300W)',
                    title: (
                        <Fragment>
                            約<span className="bold">1.3</span>時間
                        </Fragment>
                    ),
                },
                {
                    icon: <ElectricBlanket className="icon" />,
                    label: '電気毛布 (120W)',
                    title: (
                        <Fragment>
                            約<span className="bold">13.7</span>時間
                        </Fragment>
                    ),
                },
            ].map((item) => {
                return (
                    <div key={item.label} className="item">
                        {item.icon}
                        <div className="right-box">
                            <div className="label">{item.label}</div>
                            <div className="title">{item.title}</div>
                        </div>
                    </div>
                );
            }),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745399171596/IMGL1252-pc.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745402436837/%E7%8F%BE%E5%A0%B4%E4%BD%9C%E6%A5%AD-h5.jpg',
            tabLabel: '現場作業・DIY',
            tabValue: '44',
            desc: [
                {
                    icon: <CircularSaw className="icon" />,
                    label: '電動丸锯 (1400W)',
                    title: (
                        <Fragment>
                            約<span className="bold">1.2</span>時間
                        </Fragment>
                    ),
                },
                {
                    icon: <ElectricHammer className="icon" />,
                    label: '電動ハンマー (1260W)',
                    title: (
                        <Fragment>
                            約<span className="bold">1.3</span>時間
                        </Fragment>
                    ),
                },
                {
                    icon: <AngleGrinder className="icon" />,
                    label: '切断機 (1100W)',
                    title: (
                        <Fragment>
                            約<span className="bold">1.5</span>時間
                        </Fragment>
                    ),
                },
                {
                    icon: <Drill className="icon" />,
                    label: '溶接機 (1800W)',
                    title: (
                        <Fragment>
                            約<span className="bold">54</span>分
                        </Fragment>
                    ),
                },
            ].map((item) => {
                return (
                    <div key={item.label} className="item">
                        {item.icon}
                        <div className="right-box">
                            <div className="label">{item.label}</div>
                            <div className="title">{item.title}</div>
                        </div>
                    </div>
                );
            }),
        },
    ];

    return (
        <div
            className={`${styles.ElectricalAppliances} GtmModuleData-section`}
            data-section-id={styles.ElectricalAppliances}
            data-section-title={'99%の電化製品を駆動、X-Boost機能で最大2400W家電にも対応'}
        >
            <SectionPro
                label="車中泊でいつもの家電が使える、2000W高出力"
                title={
                    <p>
                        99%の電化製品を駆動、
                        <br />
                        X-Boost機能で <br />
                        最大2400W家電にも対応
                    </p>
                }
                desc="DELTA 2 Maxは、定格2000W出力で幅広い電化製品に対応します。独自のX-Boost機能*により、最大2400Wの家電も稼働可能です。IHクッキングヒーターやドライヤーなどの機器も使えるので、楽しい時間も非常時も、いつもの快適・安心空間が車内に。電動工具や高出力機器を含む99%の電化製品を稼働できるため、防災用や、工事・建築などの現場作業用にもおすすめです。"
            >
                <FTab items={tabItems} layout="LImageRText" />
                <div className="footer-text">
                    *X-Boost機能は定格出力を超える高出力の電化製品を使用可能にするEcoFlowの独自技術です。
                    電圧を下げて定格出力以内に抑えることで動作させるため、電化製品の性能は通常時と比べて低下します。
                </div>
            </SectionPro>
        </div>
    );
};

export default ElectricalAppliances;
